import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { ShiftManagementFeatureFlags } from 'modules/shift_management/lib/consts/ShiftManagementFeatureFlags'

import { MainPage } from './MainPage'
import { MainPageOld } from './MainPageOld'

const ShiftManagement = ({
  children,
  contractVersions,
}: React.PropsWithChildren<{ contractVersions: ContractVersions }>) => {
  const [{ view }] = useSchedule()
  const [{ hasFeatureFlag }] = useEnabledFeatures()

  // TODO: The work areas view is not migrated to GraphQL yet.
  return hasFeatureFlag(ShiftManagementFeatureFlags.DEV_SHIFT_MANAGEMENT_GRAPHQL_MIGRATION) &&
    view.isByEmployees ? (
    <MainPage contractVersions={contractVersions}>{children}</MainPage>
  ) : (
    <MainPageOld contractVersions={contractVersions}>{children}</MainPageOld>
  )
}

// I'm exporting this like this to make sure that we make the API of this
// component as explicit as possible and to try to enforce that the public
// interface it has is small.
export { ShiftManagement }
